//@flow

import styled from "styled-components"

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  min-height: 490px;
`



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/LocationsContainer.js